import Client from "./Client";
import { formatEventsInList } from "@/services/EventFormatter";

export async function findEvent(codeOrEventId, isSpecial) {
  const httpClient = new Client();
  let url = `events/${codeOrEventId}`;
  if (isSpecial) {
    url += "/special";
  }
  const response = await httpClient.get(url);
  return response.data;
}

export async function findEventsByCustomer(codeOrCustomerId, isSpecials) {
  const httpClient = new Client();
  let url = `events/by-customer/${codeOrCustomerId}`;
  if (isSpecials) {
    url += "/specials";
  }
  const response = await httpClient.get(url);
  return formatEventsInList(response.data);
}

export async function findCustomizationsByEvent(eventId) {
  const httpClient = new Client();
  const response = await httpClient.get(`configuration/event/${eventId}`);
  return response.data?.customJson ? JSON.parse(response.data?.customJson) : {};
}
